import { render, staticRenderFns } from "./bottom-statement.vue?vue&type=template&id=b5a0f962&scoped=true&"
import script from "./bottom-statement.vue?vue&type=script&lang=js&"
export * from "./bottom-statement.vue?vue&type=script&lang=js&"
import style0 from "./bottom-statement.vue?vue&type=style&index=0&id=b5a0f962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a0f962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow,VSpacer})
